import { render } from "./BarChartE.vue?vue&type=template&id=8166da32&scoped=true"
import script from "./BarChartE.vue?vue&type=script&lang=ts"
export * from "./BarChartE.vue?vue&type=script&lang=ts"

import "./BarChartE.vue?vue&type=style&index=0&id=8166da32&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8166da32"

export default script